<template>
  <div>
    <!-- Contenido principal -->
    <div class="spotify-layout">
      <!-- Sidebar -->
      <div class="sidebar" :class="{ 'collapsed': isCollapsed }">
        <div class="sidebar-content">
          <!-- Header del sidebar - visible solo cuando NO está colapsado -->
          <div class="sidebar-header" v-show="!isCollapsed">
            <div class="library-title" @click="toggleSidebar">
              <div class="title-container">
                <span class="compress-icon">
                  <span class="bar-icon"></span>
                  <span class="bar-icon"></span>
                </span>
                <div class="title-text">
                  Tu biblioteca
                  <div class="hover-text">{{ isCollapsed ? 'Expandir' : 'Comprimir' }}</div>
                </div>
              </div>
            </div>
            <div class="header-actions">
              <div class="dropdown-container always-top">
                <button class="action-button create-button" @click="toggleCreateMenu">
                  <span class="create-icon">+</span>
                  <span class="create-text">Crear</span>
                </button>
                <!-- Ocultar el menú original ya que ahora usamos el portal -->
                <!-- <div class="create-menu always-top" v-if="showCreateMenu">
                  <div class="create-menu-item" @click="createNewList">
                    <div class="menu-item-icon">
                      <span class="menu-icon">♪</span>
                    </div>
                    <div class="menu-item-content">
                      <div class="menu-item-title">Playlist</div>
                      <div class="menu-item-description">Crea una lista de influencers</div>
                    </div>
                  </div>
                  <div class="create-menu-item" @click="importList">
                    <div class="menu-item-icon">
                      <span class="menu-icon">↑</span>
                    </div>
                    <div class="menu-item-content">
                      <div class="menu-item-title">Importar</div>
                      <div class="menu-item-description">Importar desde archivo</div>
                    </div>
                  </div>
                </div> -->
              </div>
              <button class="action-button" @click="toggleSidebar">
                <span v-if="isCollapsed">←</span>
                <span v-else>→</span>
              </button>
            </div>
          </div>
          
          <!-- Contenido cuando está colapsado -->
          <div class="collapsed-view" v-if="isCollapsed">
            <!-- Icono de expandir arriba -->
            <div class="collapsed-icon-container">
              <button class="collapsed-icon" @click="toggleSidebar">
                <div class="arrow-icon">
                  <span class="arrow-right"></span>
                </div>
              </button>
            </div>
            
            <!-- Icono de crear en medio -->
            <div class="collapsed-icon-container dropdown-container position-relative always-top">
              <button class="collapsed-icon add-chip" @click="toggleCreateMenu">
                <span>+</span>
              </button>
              <!-- Ocultar el menú original ya que ahora usamos el portal -->
              <!-- <div class="create-menu collapsed-create-menu always-top" v-if="showCreateMenu">
                <div class="create-menu-item" @click="createNewList">
                  <div class="menu-item-icon">
                    <span class="menu-icon">♪</span>
                  </div>
                  <div class="menu-item-content">
                    <div class="menu-item-title">Playlist</div>
                    <div class="menu-item-description">Crea una lista de influencers</div>
                  </div>
                </div>
                <div class="create-menu-item" @click="importList">
                  <div class="menu-item-icon">
                    <span class="menu-icon">↑</span>
                  </div>
                  <div class="menu-item-content">
                    <div class="menu-item-title">Importar</div>
                    <div class="menu-item-description">Importar desde archivo</div>
                  </div>
                </div>
              </div> -->
            </div>
            
            <!-- Lista de playlists para vista colapsada -->
            <div class="collapsed-playlists">
              <div 
                v-for="list in currentLists.slice(0, 5)" 
                :key="list.id || list.uuid" 
                class="collapsed-playlist-item"
                :class="{ 'active': isSelectedList(list) }"
                @click="selectList(list)"
              >
                <div class="collapsed-playlist-image">
                  <img v-if="list.cover" :src="list.cover" :alt="list.title">
                  <div v-else class="collapsed-playlist-placeholder">
                    <span class="playlist-icon">♪</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filtros - solo mostrar cuando no está colapsado -->
          <div class="filter-buttons" v-if="!isCollapsed">
            <button 
              class="filter-button" 
              :class="{ 'active': activeFilter === 'personal' }"
              @click="setFilter('personal')"
            >
              Por ti
            </button>
            <button 
              class="filter-button" 
              :class="{ 'active': activeFilter === 'brandme' }"
              @click="setFilter('brandme')"
            >
              Por BrandMe
            </button>
          </div>

          <!-- Barra de búsqueda - solo mostrar cuando no está colapsado -->
          <div class="search-bar" v-if="!isCollapsed">
            <div class="search-input-container">
              <span class="search-icon">○</span>
              <input 
                type="text" 
                class="search-input" 
                placeholder="Buscar en tu biblioteca"
                v-model="searchQuery"
              >
            </div>
            <button class="list-button">☰</button>
          </div>

          <!-- Lista de playlists - solo mostrar cuando no está colapsado -->
          <div class="playlists-container" v-if="!isCollapsed">
            <div 
              v-for="list in currentLists" 
              :key="list.id || list.uuid" 
              class="playlist-item"
              :class="{ 'active': isSelectedList(list) }"
              @click="selectList(list)"
            >
              <div class="playlist-image">
                <img v-if="list.cover" :src="list.cover" :alt="list.title">
                <div v-else class="playlist-image-placeholder">
                  <span class="playlist-icon">♪</span>
                </div>
              </div>
              <div class="playlist-info">
                <div class="playlist-title">{{ list.title }}</div>
                <div class="playlist-subtitle">Lista • {{ list.owner }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contenido -->
      <div class="contenido">
        <!-- Vista de detalle de lista -->
        <div v-if="selectedList" class="list-detail-view" @scroll="handleScroll">
          <!-- Header con gradiente -->
          <div class="list-detail-header" :style="getHeaderGradient">
            <button class="back-button detail-back" @click="closeListDetail">
              ←
            </button>
            <div class="list-header">
              <div class="list-cover">
                <img :src="selectedList.cover || 'path/to/default/image'" :alt="selectedList.title">
                <div class="cover-overlay" @click="triggerFileInput">
                  <feather-icon icon="ImageIcon" size="32"></feather-icon>
                  <div class="overlay-text">Elegir foto</div>
                </div>
                <input 
                  type="file" 
                  ref="fileInput" 
                  class="hidden-file-input" 
                  accept="image/*" 
                  @change="handleFileUpload"
                />
              </div>
              <div class="list-info">
                <div class="list-type">Lista de influencers</div>
                <h1 class="list-title" @click="openEditModal">{{ selectedList.title }}</h1>
                <div class="list-stats">
                  <span class="list-count">{{ selectedListInfluencers.length }} influencers</span>
                </div>
              </div>
            </div>

            <!-- Menu de opciones para la lista -->
            <div class="list-options-menu">
              <!-- Botón de agregar a la izquierda -->
              <div class="left-actions">
                <button class="menu-action-btn add-btn" @click="addInfluencerToList">
                  <span class="add-icon">+</span>
                  <span class="add-text">Agregar influencer</span>
                </button>
              </div>
              
              <!-- Botón de opciones a la derecha -->
              <div class="right-actions">
                <div class="list-actions always-top">
                  <button class="menu-action-btn" @click="showListMenu = !showListMenu">
                    <span class="dots-icon">•••</span>
                  </button>
                  
                  <!-- Menú desplegable con opciones -->
                  <div class="list-dropdown-menu always-top" v-if="showListMenu">
                    <div class="menu-item" @click="editListDetails">
                      <span class="menu-icon">
                        <feather-icon icon="Edit2Icon" size="16"></feather-icon>
                      </span>
                      <span class="menu-text">Editar detalles</span>
                    </div>
                    <div class="menu-item" @click="deleteList">
                      <span class="menu-icon">
                        <feather-icon icon="Trash2Icon" size="16"></feather-icon>
                      </span>
                      <span class="menu-text">Eliminar</span>
                    </div>
                    <div class="menu-item" @click="makeListPrivate">
                      <span class="menu-icon">
                        <feather-icon icon="LockIcon" size="16"></feather-icon>
                      </span>
                      <span class="menu-text">Hacer privada</span>
                    </div>
                    <div class="menu-item" @click="inviteCollaborators">
                      <span class="menu-icon">
                        <feather-icon icon="UsersIcon" size="16"></feather-icon>
                      </span>
                      <span class="menu-text">Invitar colaboradores</span>
                    </div>
                    <div class="menu-item" @click="moveToFolder">
                      <span class="menu-icon">
                        <feather-icon icon="FolderIcon" size="16"></feather-icon>
                      </span>
                      <span class="menu-text">Mover a una carpeta</span>
                      <span class="arrow-icon">
                        <feather-icon icon="ChevronRightIcon" size="16"></feather-icon>
                      </span>
                    </div>
                    <div class="menu-item" @click="shareList">
                      <span class="menu-icon">
                        <feather-icon icon="Share2Icon" size="16"></feather-icon>
                      </span>
                      <span class="menu-text">Compartir</span>
                      <span class="arrow-icon">
                        <feather-icon icon="ChevronRightIcon" size="16"></feather-icon>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Nav flotante -->
          <div class="floating-nav" :class="{ 'visible': showFloatingNav }">
            <div class="nav-content">
              <div class="nav-list-info">
                <img :src="selectedList.cover" :alt="selectedList.title" class="nav-cover">
                <span class="nav-title">{{ selectedList.title }}</span>
              </div>
              <button class="play-button nav-play">
                <span class="play-icon">▶</span>
              </button>
            </div>
          </div>

          <!-- Contenido scrolleable -->
          <div class="list-detail-content">
            <!-- Lista de influencers -->
            <div class="songs-list">
              <div class="songs-header">
                <div class="song-number">#</div>
                <div class="song-title">Influencer</div>
                <div class="song-album">Red social</div>
                <div class="song-duration">Seguidores</div>
                <div class="song-verified">Verificado</div>
              </div>
              
              <div class="songs-container">
                <div v-if="loading" class="loading-message">
                  Cargando influencers...
                </div>
                <div v-else-if="selectedListInfluencers.length === 0" class="empty-message">
                  No se encontraron influencers en esta lista
                </div>
                <template v-else>
                  <div v-for="(influencer, index) in selectedListInfluencers" :key="influencer.uuid" class="song-item">
                    <div class="song-number">{{ index + 1 }}</div>
                    <div class="song-title">
                      <img :src="influencer.image" :alt="influencer.username" class="song-cover">
                      <div class="song-info">
                        <div class="song-name">{{ influencer.username }}</div>
                        <a :href="influencer.profile_url" target="_blank" class="profile-link">Ver perfil</a>
                      </div>
                    </div>
                    <div class="song-album">{{ influencer.network }}</div>
                    <div class="song-duration">{{ formatFollowers(influencer.followers) }}</div>
                    <div class="song-verified">
                      <span v-if="influencer.is_verified" class="verified-badge">✓</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- Vista principal (mostrar solo si no hay lista seleccionada) -->
        <template v-else>
          <!-- Chips de filtro -->
          <div class="filter-chips">
            <button 
              class="filter-chip" 
              :class="{ 'active': activeContentFilter === 'all' }"
              @click="setContentFilter('all')"
            >
              Todo
            </button>
            <button 
              class="filter-chip" 
              :class="{ 'active': activeContentFilter === 'yours' }"
              @click="setContentFilter('yours')"
            >
              Tu
            </button>
            <button 
              class="filter-chip" 
              :class="{ 'active': activeContentFilter === 'brandme' }"
              @click="setContentFilter('brandme')"
            >
              BrandMe
            </button>
          </div>

          <!-- Sección "Hecho para" -->
          <section v-if="activeContentFilter === 'all' || activeContentFilter === 'yours'" class="made-for-section" :class="{ 'full-view': showAllPersonalLists }">
            <div class="section-header">
              <div class="section-title">
                <button 
                  v-if="showAllPersonalLists" 
                  class="back-button" 
                  @click="toggleShowPersonalLists"
                >
                  ←
                </button>
                Tus listas 
              </div>
              <button 
                v-if="!showAllPersonalLists" 
                class="show-all" 
                @click="toggleShowPersonalLists"
              >
                Mostrar todo
              </button>
            </div>
            
            <!-- Vista normal -->
            <div v-if="!showAllPersonalLists" class="cards-grid-scroll">
              <div v-if="loading" class="loading-message">
                Cargando listas...
              </div>
              <div v-else-if="lists.length === 0" class="empty-message">
                No se encontraron listas personalizadas
              </div>
              <template v-else>
                <div class="cards-grid-horizontal">
                  <div 
                    v-for="list in lists.slice(0, 20)" 
                    :key="list.uuid" 
                    class="card"
                    @click="selectList(list)"
                  >
                    <div class="card-image" :class="getRandomGradient()">
                      <img 
                        :src="list.cover || 'path/to/default/image'" 
                        :alt="list.title"
                      >
                    </div>
                    <div class="card-description">{{ list.title }}</div>
                  </div>
                </div>
              </template>
            </div>

            <!-- Vista completa -->
            <div v-else class="cards-grid">
              <div v-if="loading" class="loading-message">
                Cargando listas...
              </div>
              <div v-else-if="lists.length === 0" class="empty-message">
                No se encontraron listas personalizadas
              </div>
              <template v-else>
                <div 
                  v-for="list in lists" 
                  :key="list.uuid" 
                  class="card"
                  @click="selectList(list)"
                >
                  <div class="card-image" :class="getRandomGradient()">
                    <img 
                      :src="list.cover || 'path/to/default/image'" 
                      :alt="list.title"
                    >
                  </div>
                  <div class="card-description">{{ list.title }}</div>
                </div>
              </template>
            </div>
          </section>

          <!-- Sección "Estaciones populares" -->
          <section v-if="activeContentFilter === 'all' || activeContentFilter === 'brandme'" class="popular-stations" :class="{ 'full-view': showAllPreLists }">
            <div class="section-header">
              <div class="section-title">
                <button 
                  v-if="showAllPreLists" 
                  class="back-button" 
                  @click="toggleShowAllPreLists"
                >
                  ←
                </button>
                Estaciones hechas por BrandMe
              </div>
              <button 
                v-if="!showAllPreLists" 
                class="show-all" 
                @click="toggleShowAllPreLists"
              >
                Mostrar todo
              </button>
            </div>
            
            <!-- Vista de scroll horizontal -->
            <div v-if="!showAllPreLists" class="cards-grid-scroll">
              <div class="cards-grid-horizontal">
                <div 
                  v-for="list in preLists" 
                  :key="list.id" 
                  class="radio-card"
                  @click="selectList(list)"
                >
                  <div class="radio-image" :class="list.color || 'yellow'">
                    <span class="radio-label">RADIO</span>
                    <img 
                      :src="list.cover || 'path/to/default/image'" 
                      :alt="list.title"
                    >
                  </div>
                  <div class="card-description">{{ list.description || 'Lista pre fabricada' }}</div>
                </div>
              </div>
            </div>

            <!-- Vista completa en grid -->
            <div v-else class="cards-grid">
              <div 
                v-for="list in preLists" 
                :key="list.id" 
                class="radio-card"
                @click="selectList(list)"
              >
                <div class="radio-image" :class="list.color || 'yellow'">
                  <span class="radio-label">RADIO</span>
                  <img 
                    :src="list.cover || 'path/to/default/image'" 
                    :alt="list.title"
                  >
                </div>
                <div class="card-title">{{ list.title }}</div>
                <div class="card-description">{{ list.description || 'Lista pre fabricada' }}</div>
              </div>
            </div>
            
            <!-- Añadir la sección de listas destacadas después de las estaciones -->
            <div v-if="activeContentFilter === 'all' || activeContentFilter === 'brandme'" class="featured-lists-section">
              <div class="section-header">
                <h2 class="section-title">Listas destacadas</h2>
              </div>
              
              <div class="featured-lists-grid">
                <div v-if="loading" class="loading-message">
                  Cargando listas destacadas...
                </div>
                <div v-else-if="featuredLists.length === 0" class="empty-message">
                  No se encontraron listas destacadas
                </div>
                <template v-else>
                  <div 
                    v-for="list in featuredLists" 
                    :key="list.uuid" 
                    class="featured-list-card"
                    @click="selectList(list)"
                  >
                    <div class="spotify-style-card" 
                      :class="getRandomGradient()"
                      @mouseenter="getInfluencersForList(list.uuid || list.id)"
                    >
                      <!-- Círculos que aparecen en hover -->
                      <div class="hover-circle-1"></div>
                      <div class="hover-circle-2"></div>
                      <div class="hover-circle-3"></div>
                      
                      <!-- Contenedor de imágenes de influencers difuminadas -->
                      <div class="influencers-background">
                        <div 
                          v-for="(influencer, index) in getInfluencerAvatars(list.uuid || list.id).slice(0, 5)" 
                          :key="index"
                          class="influencer-bg-image"
                          :style="{
                            backgroundImage: `url(${influencer.avatar || influencer.profile_photo || 'path/to/default/avatar'})`,
                            animationDelay: `${index * 3}s`
                          }"
                        ></div>
                      </div>
                      
                      <div class="card-header">
                        <div class="card-thumbnail">
                          <img :src="list.cover || 'path/to/default/image'" :alt="list.title">
                        </div>
                        <div class="card-header-text">
                          <h2 class="card-main-title">{{ list.title }}</h2>
                          <div class="card-subtitle">Por BrandMe</div>
                        </div>
                      </div>
                      
                      <!-- Área de contenido con fondo degradado -->
                      <div class="card-content-area">
                        <!-- Aquí podría ir contenido adicional en el futuro -->
                      </div>
                      
                      <!-- Descripción que aparecerá solo en hover -->
                      <div class="card-hover-overlay">
                        <p class="card-description">Con {{ list.description || 'los mejores influencers seleccionados especialmente para ti' }}</p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </section>
        </template>
      </div>
    </div>
    
    <!-- Componente de sidebar para agregar influencers -->
    <add-influencer-sidebar
      v-if="showAddInfluencerSidebar"
      :is-visible="showAddInfluencerSidebar"
      :list-id="selectedList ? (selectedList.uuid || selectedList.id) : ''"
      @close="closeAddInfluencerSidebar"
      @influencers-added="handleInfluencersAdded"
    />
    
    <!-- Modal personalizado para editar detalles de la lista -->
    <div v-if="showEditModal" class="custom-modal-backdrop">
      <div class="custom-modal">
        <div class="edit-modal-header">
          <h3 class="edit-modal-title" style="color: white !important;">Editar datos</h3>
          <button 
            type="button" 
            class="edit-modal-close" 
            @click="showEditModal = false"
          >
            <span>&times;</span>
          </button>
        </div>
        
        <div class="edit-modal-content">
          <div class="edit-modal-row">
            <div class="edit-modal-cover-container">
              <div class="edit-modal-cover">
                <img :src="selectedList ? (selectedList.cover || 'path/to/default/image') : 'path/to/default/image'" alt="Portada">
              </div>
            </div>
            
            <div class="edit-modal-form">
              <div class="form-group mb-3">
                <input 
                  type="text" 
                  class="edit-form-control" 
                  v-model="editListForm.title" 
                  placeholder="Mi playlist n.° 7"
                >
              </div>
              
              <div class="form-group">
                <textarea 
                  class="edit-form-control" 
                  v-model="editListForm.description" 
                  placeholder="Agrega una descripción opcional"
                  rows="4"
                ></textarea>
              </div>
            </div>
          </div>
          
          <div class="edit-modal-disclaimer">
            Al continuar, aceptas darle acceso a Spotify a la imagen que decidas subir. Asegúrate de tener los derechos para subir la imagen.
          </div>
          
          <div class="edit-modal-actions">
            <button class="edit-save-btn" @click="saveListDetails">Guardar</button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Portal para los menús -->
    <div class="menu-portal">
      <!-- Menú de creación -->
      <div 
        class="portal-menu create-menu-portal" 
        v-if="showCreateMenu"
        :style="{
          top: menuPortalPosition.top,
          left: menuPortalPosition.left
        }"
      >
        <div class="create-menu-item" @click="createNewList">
          <div class="menu-item-icon">
            <span class="menu-icon">♪</span>
          </div>
          <div class="menu-item-content">
            <div class="menu-item-title">Playlist</div>
            <div class="menu-item-description">Crea una lista de influencers</div>
          </div>
        </div>
        <div class="create-menu-item" @click="importList">
          <div class="menu-item-icon">
            <span class="menu-icon">↑</span>
          </div>
          <div class="menu-item-content">
            <div class="menu-item-title">Importar</div>
            <div class="menu-item-description">Importar desde archivo</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listService from '@/services/lists'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import AddInfluencerSidebar from './AddInfluencerSidebar.vue'

export default {
  name: 'ListV2',
  components: {
    'feather-icon': FeatherIcon,
    AddInfluencerSidebar,

  },
  data() {
    return {
      isCollapsed: false,
      searchQuery: '',
      lists: [],
      preLists: [],
      selectedList: null,
      selectedListInfluencers: [],
      loading: true,
      activeFilter: 'personal',
      showAllPreLists: false,
      showAllPersonalLists: false,
      showFloatingNav: false,
      showCreateMenu: false,
      showListMenu: false,
      listSearchQuery: '',
      
      // Para el sidebar de agregar influencers
      showAddInfluencerSidebar: false,
      
      // Para posicionar el portal del menú
      menuPortalPosition: {
        top: '60px',
        left: '220px'
      },
      
      // Para el modal de edición
      showEditModal: false,
      editListForm: {
        title: '',
        description: ''
      },
      featuredLists: [],
      loadedInfluencers: {},
      activeContentFilter: 'all', // Valor por defecto: mostrar todo
    }
  },
  computed: {
    filteredLists() {
      if (!this.searchQuery) return this.lists
      const query = this.searchQuery.toLowerCase()
      return this.lists.filter(list => list.title.toLowerCase().includes(query) || list.owner.toLowerCase().includes(query))
    },
    currentLists() {
      if (!this.searchQuery) {
        return this.activeFilter === 'personal' ? this.lists : this.preLists
      }
      const query = this.searchQuery.toLowerCase()
      const sourceList = this.activeFilter === 'personal' ? this.lists : this.preLists
      return sourceList.filter(list => list.title.toLowerCase().includes(query) || (list.owner && list.owner.toLowerCase().includes(query)))
    },
    getHeaderGradient() {
      if (this.selectedList?.color_palette) {
        const colors = this.selectedList.color_palette;
        if (Array.isArray(colors) && colors.length >= 2) {
          return {
            background: `linear-gradient(180deg, ${colors[0]} 0%, ${colors[1]} 85%, #121212 95%)`
          };
        }
        return {
          background: `linear-gradient(180deg, ${colors} 0%, rgba(18, 18, 18, 0.8) 85%, #121212 95%)`
        };
      }
      return {
        background: 'linear-gradient(180deg, rgba(83, 83, 83, 0.5) 0%, #121212 95%)'
      };
    },
    // Asegurar que tenemos acceso a las listas BrandMe
    brandmeLists() {
      return this.preLists || [];
    },
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
    },
    async loadInfluencers(uuid) {
      try {
        console.log('Cargando influencers para uuid:', uuid);
        const response = await listService.getInfluencers(uuid);
        console.log('Respuesta de influencers:', response);
        
        // Mapear los influencers para asegurar que tengan un atributo 'image'
        const responseData = Array.isArray(response) ? response : Array.isArray(response?.results) ? response.results : Array.isArray(response?.response) ? response.response : [];
        const mappedInfluencers = responseData.map(influencer => ({
          ...influencer,
          image: influencer.image || influencer.profile_image_url || influencer.avatar || 'path/to/default-avatar.png'
        }));
        
        this.selectedListInfluencers = mappedInfluencers;
        console.log('Influencers cargados:', this.selectedListInfluencers);
      } catch (error) {
        console.error('Error al cargar influencers:', error);
        this.selectedListInfluencers = [];
      }
    },
    async loadPreListInfluencers(uuid) {
      try {
        console.log('Cargando influencers de pre-lista para uuid:', uuid);
        const response = await listService.getPreListsInfluencers(uuid);
        console.log('Respuesta de influencers de pre-lista:', response);
        
        // Mapear los influencers para asegurar que tengan un atributo 'image'
        const responseData = Array.isArray(response) ? response : Array.isArray(response?.results) ? response.results : Array.isArray(response?.response) ? response.response : [];
        const mappedInfluencers = responseData.map(influencer => ({
          ...influencer,
          image: influencer.image || influencer.profile_image_url || influencer.avatar || 'path/to/default-avatar.png'
        }));
        
        this.selectedListInfluencers = mappedInfluencers;
        console.log('Influencers de pre-lista cargados:', this.selectedListInfluencers);
      } catch (error) {
        console.error('Error al cargar influencers de pre-lista:', error);
        this.selectedListInfluencers = [];
      }
    },
    scrollToTop() {
      // Esta función ya no se usa, pero la mantenemos por si es referenciada en algún otro lugar
      console.log('Método scrollToTop() ha sido desactivado en ListV2.vue');
    },
    fetchLists() {
      listService.getLists().then((response) => {
        console.log('Respuesta de listas:', response); // Para debug
        this.lists = Array.isArray(response) ? response : (response?.results || []);
        this.loading = false;
      }).catch(error => {
        console.error('Error al cargar listas:', error);
        this.lists = [];
        this.loading = false;
      })
    },
    fetchPreLists() {
      return listService.getPreLists().then((response) => {
        console.log('Respuesta de pre-listas:', response); // Para debug
        this.preLists = Array.isArray(response) ? response : (response?.results || []);
        this.loading = false;
        
        // Seleccionar listas destacadas después de cargar las pre-listas
        this.selectFeaturedLists();
      }).catch(error => {
        console.error('Error al cargar pre-listas:', error);
        this.preLists = [];
        this.featuredLists = [];
        this.loading = false;
      })
    },
    toggleShowAllPreLists() {
      this.showAllPreLists = !this.showAllPreLists
    },
    getRandomGradient() {
      const gradients = [
        'gradient-purple',
        'gradient-blue',
        'gradient-cyan',
        'gradient-red',
        'gradient-pink'
      ];
      return gradients[Math.floor(Math.random() * gradients.length)];
    },
    setFilter(filter) {
      this.activeFilter = filter
      this.searchQuery = ''
    },
    toggleShowPersonalLists() {
      this.showAllPersonalLists = !this.showAllPersonalLists
    },
    formatFollowers(followers) {
      if (followers >= 1000000) {
        return `${(followers / 1000000).toFixed(1)}M`
      } else if (followers >= 1000) {
        return `${(followers / 1000).toFixed(1)}K`
      }
      return followers.toString()
    },
    closeListDetail() {
      this.selectedList = null;
      this.selectedListInfluencers = [];
    },
    handleScroll(event) {
      const headerHeight = 340; // Altura hasta el final del título grande
      const scrollTop = event.target.scrollTop;
      this.showFloatingNav = scrollTop >= headerHeight;
    },
    async selectList(list) {
      console.log('Lista seleccionada completa:', JSON.stringify(list));
      
      // Crear una copia limpia de la lista seleccionada
      this.selectedList = {
        id: list.id || null,
        uuid: list.uuid || null,
        title: list.title,
        owner: list.owner,
        cover: list.cover,
        color_palette: list.color_palette,
        is_user_list: list.is_user_list
      };
      
      // Determinar qué método de carga de influencers usar
      if (list && (list.uuid || list.id)) {
        const listId = list.uuid || list.id;
        
        try {
          if (list.is_user_list) {
            // Si es una lista de usuario, usar getInfluencers
            await this.loadInfluencers(listId);
          } else {
            // Si no es una lista de usuario, usar getPreListsInfluencers
            await this.loadPreListInfluencers(listId);
          }
          
        } catch (error) {
          console.error('Error al cargar influencers:', error);
          this.selectedListInfluencers = [];
        }
      } else {
        console.error('La lista seleccionada no tiene uuid ni id:', list);
        this.selectedListInfluencers = [];
      }
    },
    toggleCreateMenu(event) {
      // Detener la propagación para que el evento click no llegue al document
      event.stopPropagation()
      this.showCreateMenu = !this.showCreateMenu
      
      // Si se cierra el menú, no es necesario hacer nada más
      if (!this.showCreateMenu) return;
      
      // Calcular la posición del portal
      if (event && event.target) {
        // Obtener información de posición del elemento que se hizo clic
        const button = event.target.closest('button');
        if (button) {
          const rect = button.getBoundingClientRect();
          
          // Establecer la posición para el portal del menú
          if (this.isCollapsed) {
            // Para la vista colapsada (menú a la derecha del botón)
            this.menuPortalPosition = {
              top: `${rect.top}px`,
              left: `${rect.left + rect.width + 10}px`
            };
          } else {
            // Para la vista normal (menú debajo del botón)
            this.menuPortalPosition = {
              top: `${rect.bottom + 5}px`,
              left: `${rect.left}px`
            };
          }
        }
      }
    },
    createNewList() {
      // Cerrar el menú desplegable
      this.showCreateMenu = false;
      
      // Crear un objeto para la nueva lista vacía con valores por defecto
      const listData = {
        title: 'Nueva lista de influencers',
        description: 'Lista personalizada creada por ti',
      };
      
      // Crear FormData para enviar al servicio
      const formData = new FormData();
      formData.append('title', listData.title);
      formData.append('description', listData.description);
      formData.append('order', 0);
      
      // Crear un Blob de una imagen temporal
      this.createDefaultImage().then(blob => {
        // Añadir el blob como archivo para el cover
        formData.append('cover', blob, 'default-cover.jpg');
        
        // Añadir la paleta de colores
        formData.append('color_palette', JSON.stringify(['#1e3264', '#121212']));
        
        // Llamar al servicio para crear la lista
        this.loading = true;
        listService.createList(formData)
          .then(response => {
            console.log('Lista creada con éxito:', response);
            
            // Si la respuesta contiene la lista creada, seleccionarla
            if (response && (response.uuid || response.id)) {
              this.selectedList = response;
              this.selectedListInfluencers = [];
              
              // Actualizar la lista de listas
              this.fetchLists();
            }
            this.loading = false;
          })
          .catch(error => {
            console.error('Error al crear la lista:', error);
            this.loading = false;
          });
      });
    },
    
    /**
     * Crea una imagen por defecto como Blob
     * @returns {Promise<Blob>} Una promesa que resuelve a un Blob de imagen
     */
    createDefaultImage() {
      return new Promise((resolve) => {
        // Crear un canvas para generar una imagen
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Establecer dimensiones
        canvas.width = 300;
        canvas.height = 300;
        
        // Crear un gradiente como fondo
        const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#1e3264');
        gradient.addColorStop(1, '#121212');
        
        // Aplicar el gradiente
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Añadir un texto
        ctx.fillStyle = 'white';
        ctx.font = 'bold 30px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('Nueva Lista', canvas.width / 2, canvas.height / 2);
        
        // Convertir el canvas a blob
        canvas.toBlob(blob => {
          resolve(blob);
        }, 'image/jpeg', 0.95);
      });
    },
    importList() {
      // Implementa la lógica para importar una lista
      console.log('Importar lista');
    },
    closeMenuOnClickOutside(event) {
      // Verificar si algún menú está abierto
      if (!this.showCreateMenu && !this.showListMenu) return;
      
      // Obtener todos los contenedores de menú y botones que lo activan
      const dropdownContainer = document.querySelector('.dropdown-container');
      const collapsedContainer = document.querySelector('.collapsed-icon-container.dropdown-container');
      const listActionsContainer = document.querySelector('.right-actions');
      
      // Verificar si el clic fue fuera de todos los elementos relacionados a los menús
      const isOutsideRegularMenu = dropdownContainer && !dropdownContainer.contains(event.target);
      const isOutsideCollapsedMenu = collapsedContainer && !collapsedContainer.contains(event.target);
      const isOutsideListMenu = listActionsContainer && !listActionsContainer.contains(event.target);
      
      // Si el clic fue fuera de los menús relevantes, cerrarlos
      if ((this.isCollapsed && isOutsideCollapsedMenu) || (!this.isCollapsed && isOutsideRegularMenu)) {
        this.showCreateMenu = false;
      }
      
      if (isOutsideListMenu) {
        this.showListMenu = false;
      }
    },
    editListDetails() {
      // Abrir el modal de edición
      this.openEditModal();
    },
    openEditModal() {
      if (!this.selectedList) return;
      
      // Inicializar el formulario con los datos actuales de la lista
      this.editListForm = {
        title: this.selectedList.title || '',
        description: this.selectedList.description || ''
      };
      
      // Mostrar el modal
      this.showEditModal = true;
    },
    saveListDetails() {
      if (!this.selectedList) return;
      
      // Mostrar un estado de carga
      this.loading = true;
      
      // Crear FormData para enviar al servicio
      const formData = new FormData();
      formData.append('title', this.editListForm.title);
      formData.append('description', this.editListForm.description);
      
      // Obtener el UUID o ID de la lista
      const listId = this.selectedList.uuid || this.selectedList.id;
      
      // Llamar al servicio para actualizar los detalles
      listService.updateList(formData, listId)
        .then(response => {
          console.log('Detalles actualizados con éxito:', response);
          
          // Actualizar los datos de la lista localmente
          this.selectedList = {
            ...this.selectedList,
            title: this.editListForm.title,
            description: this.editListForm.description
          };
          
          // Mostrar una notificación al usuario
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Éxito',
              variant: 'success',
              solid: true,
              autoHideDelay: 5000,
            },
            slots: {
              default: () => 'Los detalles de la lista se han actualizado correctamente'
            }
          });
          
          // Recargar las listas para obtener la información actualizada
          this.fetchLists();
          
          // Cerrar el modal
          this.showEditModal = false;
        })
        .catch(error => {
          console.error('Error al actualizar los detalles:', error);
          
          // Mostrar una notificación de error al usuario
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            },
            slots: {
              default: () => 'No se pudieron actualizar los detalles de la lista'
            }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteList() {
      // Implementa la lógica para eliminar la lista
      console.log('Eliminar la lista');
    },
    makeListPrivate() {
      // Implementa la lógica para hacer la lista privada
      console.log('Hacer la lista privada');
    },
    inviteCollaborators() {
      // Implementa la lógica para invitar colaboradores a la lista
      console.log('Invitar colaboradores a la lista');
    },
    moveToFolder() {
      // Implementa la lógica para mover la lista a una carpeta
      console.log('Mover la lista a una carpeta');
    },
    shareList() {
      // Implementa la lógica para compartir la lista
      console.log('Compartir la lista');
    },
    addInfluencerToList() {
      // Abrir el sidebar para añadir influencers
      this.showAddInfluencerSidebar = true;
    },
    closeAddInfluencerSidebar() {
      this.showAddInfluencerSidebar = false;
    },
    handleInfluencersAdded(influencers) {
      if (!influencers || influencers.length === 0 || !this.selectedList) return;
      
      // Agregar los influencers a la lista actual
      this.selectedListInfluencers = [
        ...this.selectedListInfluencers,
        ...influencers
      ];
      
      // En un caso real, aquí realizaríamos la llamada a la API para guardar los cambios
      console.log('Influencers agregados a la lista:', influencers);
    },
    debounceSearchInfluencer() {
      if (this.searchInfluencerTimeout) {
        clearTimeout(this.searchInfluencerTimeout);
      }
      
      this.searchInfluencerTimeout = setTimeout(() => {
        this.searchInfluencers();
      }, 500);
    },
    async searchInfluencers() {
      this.loadingInfluencers = true;
      
      try {
        // Normalmente esto sería una llamada a la API
        // Simulamos una respuesta para fines de demostración
        await new Promise(resolve => setTimeout(resolve, 800));
        
        // Simulación de resultados basados en los filtros
        let mockData = [
          { uuid: '1', username: 'influencer_fashion', followers: 345000, network: 'instagram', image: '' },
          { uuid: '2', username: 'travel_explorer', followers: 120000, network: 'tiktok', image: '' },
          { uuid: '3', username: 'tech_reviews', followers: 890000, network: 'youtube', image: '' },
          { uuid: '4', username: 'foodie_expert', followers: 75000, network: 'instagram', image: '' },
          { uuid: '5', username: 'fitness_guru', followers: 1230000, network: 'instagram', image: '' },
          { uuid: '6', username: 'gaming_pro', followers: 560000, network: 'youtube', image: '' },
          { uuid: '7', username: 'beauty_trends', followers: 670000, network: 'tiktok', image: '' },
          { uuid: '8', username: 'news_reporter', followers: 430000, network: 'twitter', image: '' },
        ];
        
        // Filtrar por búsqueda
        if (this.searchInfluencerQuery) {
          const query = this.searchInfluencerQuery.toLowerCase();
          mockData = mockData.filter(inf => inf.username.toLowerCase().includes(query) || inf.network.toLowerCase().includes(query));
        }
        
        // Filtrar por red social
        if (this.influencerFilter.network) {
          mockData = mockData.filter(inf => inf.network.toLowerCase() === this.influencerFilter.network.toLowerCase());
        }
        
        // Filtrar por seguidores mínimos
        if (this.influencerFilter.minFollowers) {
          mockData = mockData.filter(inf => inf.followers >= this.influencerFilter.minFollowers);
        }
        
        // Filtrar por seguidores máximos
        if (this.influencerFilter.maxFollowers) {
          mockData = mockData.filter(inf => inf.followers <= this.influencerFilter.maxFollowers);
        }
        
        this.searchedInfluencers = mockData;
      } catch (error) {
        console.error('Error al buscar influencers:', error);
        this.searchedInfluencers = [];
      } finally {
        this.loadingInfluencers = false;
      }
    },
    toggleInfluencerSelection(influencer) {
      const index = this.selectedInfluencers.indexOf(influencer.uuid);
      if (index === -1) {
        this.selectedInfluencers.push(influencer.uuid);
      } else {
        this.selectedInfluencers.splice(index, 1);
      }
    },
    addSelectedInfluencersToList() {
      if (!this.selectedList || this.selectedInfluencers.length === 0) return;
      
      // Obtener los datos completos de los influencers seleccionados
      const selectedInfluencerData = this.searchedInfluencers.filter(
        inf => this.selectedInfluencers.includes(inf.uuid)
      );
      
      // Agregar los influencers a la lista actual
      this.selectedListInfluencers = [
        ...this.selectedListInfluencers,
        ...selectedInfluencerData
      ];
      
      // Cerrar el sidebar
      this.closeAddInfluencerSidebar();
      
      // En un caso real, aquí realizaríamos la llamada a la API para guardar los cambios
      console.log('Influencers agregados a la lista:', selectedInfluencerData);
    },
    getNetworkIcon(network) {
      const networkIcons = {
        'instagram': 'InstagramIcon',
        'youtube': 'YoutubeIcon',
        'tiktok': 'VideoIcon', // Feather no tiene ícono específico para TikTok
        'twitter': 'TwitterIcon'
      };
      
      return networkIcons[network] || 'UserIcon';
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // Crear una URL para la vista previa
        const previewUrl = URL.createObjectURL(file);
        
        // Actualizar temporalmente la imagen para mostrar la vista previa
        this.selectedList = {
          ...this.selectedList,
          cover: previewUrl
        };
        
        // Crear un FormData para enviar la imagen al servidor
        const formData = new FormData();
        formData.append('cover', file);
        formData.append('uuid', this.selectedList.uuid || this.selectedList.id);
        
        // Actualizar la imagen de la lista (esta parte sería con la API real)
        this.updateListCover(formData);
      }
    },
    updateListCover(formData) {
      // Mostrar un estado de carga
      this.loading = true;
      
      // Obtener el UUID o ID de la lista
      const listId = this.selectedList.uuid || this.selectedList.id;
      
      // Llamar al servicio para actualizar la portada
      listService.updateList(formData, listId)
        .then(response => {
          console.log('Portada actualizada con éxito:', response);
          
          // Mostrar una notificación al usuario (si existe un sistema de notificaciones)
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Éxito',
              variant: 'success',
              solid: true,
              autoHideDelay: 5000,
            },
            slots: {
              default: () => 'La imagen de portada se ha actualizado correctamente'
            }
          });
          
          // Recargar las listas para obtener la información actualizada
          this.fetchLists();
        })
        .catch(error => {
          console.error('Error al actualizar la portada:', error);
          
          // Mostrar una notificación de error al usuario
          this.$toast({
            component: 'b-toast',
            props: {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000,
            },
            slots: {
              default: () => 'No se pudo actualizar la imagen de portada'
            }
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isSelectedList(list) {
      if (!this.selectedList) return false;
      
      // Verificar por ID
      if (list.id && this.selectedList.id) {
        return list.id === this.selectedList.id;
      }
      
      // Verificar por UUID
      if (list.uuid && this.selectedList.uuid) {
        return list.uuid === this.selectedList.uuid;
      }
      
      return false;
    },
    // Método para seleccionar listas destacadas aleatoriamente
    selectFeaturedLists() {
      // Si no hay listas predefinidas por BrandMe, retornar
      if (!this.preLists || this.preLists.length === 0) {
        this.featuredLists = [];
        return;
      }
      
      // Crear una copia del array de preLists para no modificar el original
      const preListsCopy = [...this.preLists];
      
      // Mezclar el array de forma aleatoria
      for (let i = preListsCopy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [preListsCopy[i], preListsCopy[j]] = [preListsCopy[j], preListsCopy[i]];
      }
      
      // Tomar las primeras 6 listas o menos si no hay suficientes
      this.featuredLists = preListsCopy.slice(0, 6);
    },
    // Actualizar el método donde se cargan las listas para llamar a selectFeaturedLists
    // Por ejemplo, después de cargar preLists en loadPreMadeLists o en mounted/created
    async loadPreMadeLists() {
      if (this.preLists && this.preLists.length > 0) {
        // Si ya tenemos listas precargadas, simplemente seleccionamos destacadas
        this.selectFeaturedLists();
      } else {
        // Si no, esperamos a que se carguen
        await this.fetchPreLists();
        this.selectFeaturedLists();
      }
    },
    getInfluencersForList(listId) {
      // Si ya tenemos los influencers cargados, no hacemos nada
      if (this.loadedInfluencers[listId]) return;
      
      // Cargar los influencers de la lista
      listService.getPreListsInfluencers(listId)
        .then(response => {
          // Mapear los influencers para asegurar que tengan un atributo de imagen
          const responseData = Array.isArray(response) ? response : Array.isArray(response?.results) ? response.results : Array.isArray(response?.response) ? response.response : [];
          
          const mappedInfluencers = responseData.map(influencer => ({
            ...influencer,
            avatar: influencer.image || influencer.profile_image_url || influencer.avatar || 'path/to/default-avatar.png'
          }));
          
          // Actualizar el estado con los influencers cargados
          this.$set(this.loadedInfluencers, listId, mappedInfluencers);
        })
        .catch(error => {
          console.error('Error al cargar influencers:', error);
        });
    },
    
    getInfluencerAvatars(listId) {
      return this.loadedInfluencers[listId] || [];
    },
    setContentFilter(filter) {
      this.activeContentFilter = filter;
    },
  },
  created() {
    this.fetchLists()
    this.fetchPreLists() // Este ya llama a selectFeaturedLists
    // Agregar listener para cerrar el menú al hacer clic en cualquier lugar
    document.addEventListener('click', this.closeMenuOnClickOutside)
  },
  mounted() {
    // Si ya existe un método mounted, añadir esto dentro
    // Si no existe, descomentar estas líneas
    // this.loadPreMadeLists();
  },
  beforeDestroy() {
    // Eliminar el listener cuando el componente se destruye
    document.removeEventListener('click', this.closeMenuOnClickOutside)
  }
}
</script>

<style scoped>
/* Estilos para garantizar que los menús aparezcan en la parte superior */
.dropdown-container, 
.create-menu, 
.collapsed-create-menu, 
.list-dropdown-menu {
  position: relative !important;
}

.create-menu, 
.collapsed-create-menu, 
.list-dropdown-menu {
  position: absolute !important;
  top: auto;
  z-index: 9999 !important;
}

/* Hacer que el menú sea un elemento top-level para evitar recortes */
.spotify-layout {
  overflow: visible !important;
}

.sidebar {
  overflow: visible !important;
}

.sidebar-content, 
.header-actions, 
.list-actions {
  overflow: visible !important;
  position: relative !important;
}

.spotify-layout {
  display: flex;
  min-height: 100vh;
  background-color: white;
  padding: 8px;
  gap: 8px;
  overflow: visible !important;
}

.sidebar {
  width: 25%;
  background-color: #121212;
  border-radius: 10px;
  padding: 5px;
  height: calc(100vh - 16px);
  transition: all 0.3s ease;
  overflow: visible !important;
}

.sidebar.collapsed {
  width: 120px;
  padding: 10px;
}

.sidebar.collapsed .sidebar-content {
  padding: 0;
}

.sidebar-content {
  color: white;
}

.contenido {
  flex: 1;
  width: 75%;
  background-color: #121212;
  border-radius: 10px;
  color: white;
  height: calc(100vh - 16px);
  overflow-y: auto;
  position: relative;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-header h2 {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

.show-all {
  background: none;
  border: none;
  color: #b3b3b3;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.show-all:hover {
  color: white;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  margin-bottom: 48px;
}

.card, .radio-card {
  background: #181818;
  padding: 16px;
  border-radius: 8px;
  transition: background-color 0.3s;
  cursor: pointer;
}

.card:hover, .radio-card:hover {
  background-color: #282828;
}

.card-image, .radio-image {
  position: relative;
  width: 100%;
  aspect-ratio: 1; /* Restaurar al aspect-ratio original */
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
}

.card-image img, .radio-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gradient-purple { background: linear-gradient(135deg, #450af5, #c4efd9); }
.gradient-blue { background: linear-gradient(135deg, #1e3264, #b4b4b4); }
.gradient-cyan { background: linear-gradient(135deg, #148a08, #b4b4b4); }
.gradient-red { background: linear-gradient(135deg, #e61e32, #b4b4b4); }
.gradient-pink { background: linear-gradient(135deg, #bc5900, #b4b4b4); }

.yellow { background-color: #ffd966; }
.green { background-color: #96d36f; }

.radio-label {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
}

h3 {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px;
  color: white;
}

p {
  font-size: 14px;
  color: #b3b3b3;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Personalizar scrollbar */
.contenido::-webkit-scrollbar {
  width: 8px;
}

.contenido::-webkit-scrollbar-track {
  background: transparent;
}

.contenido::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.contenido::-webkit-scrollbar-thumb:hover {
  background: #666;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  /* Eliminar el borde inferior */
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.1); */
}

.library-title {
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  cursor: pointer;
}

.library-icon {
  font-size: 24px;
  color: white;
}

.library-title h2 {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin: 0;
}

.title-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title-text {
  position: relative;
  font-size: 16px;
  font-weight: 600;
  color: white;
  transition: transform 0.3s ease;
}

.compress-icon {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  width: 16px;
  height: 16px;
  opacity: 0;
  transition: all 0.3s ease;
  margin-right: -5px;
}

.library-title:hover .compress-icon {
  opacity: 1;
}

.library-title:hover .title-text {
  transform: translateX(5px);
}

.bar-icon {
  display: block;
  width: 100%;
  height: 2px;
  background-color: white;
  border-radius: 1px;
  transition: all 0.3s ease;
}

.library-title:hover .bar-icon:first-child {
  transform: translateY(1px);
}

.library-title:hover .bar-icon:last-child {
  transform: translateY(-1px);
}

.hover-text {
  position: absolute;
  top: -30px;
  left: 0;
  background-color: #282828;
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  white-space: nowrap;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.2s ease;
  pointer-events: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  z-index: 1001;
}

.library-title:hover .hover-text {
  opacity: 1;
  transform: translateY(0);
}

.header-actions {
  display: flex;
  gap: 8px;
}

.action-button {
  background: none;
  border: none;
  color: #969696;
  font-size: 20px;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.action-button:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.filter-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 4px;
  flex-wrap: wrap;
}

.filter-button {
  background-color: #232323;
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 32px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-button:hover {
  background-color: #2a2a2a;
}

.filter-button.active {
  background-color: white;
  color: black;
}

.search-bar {
  display: flex;
  align-items: center;
  padding: 4px 8px;
}

.search-input-container {
  display: flex;
  align-items: center;
  background-color: #242424;
  border-radius: 4px;
  padding: 4px 10px; /* Reducido de 6px 12px */
  flex: 1;
  margin-right: 8px;
}

.search-icon {
  display: none; /* Ocultar el icono */
}

.search-input {
  background: transparent;
  border: none;
  color: white;
  font-size: 13px; /* Reducido de 14px */
  width: 100%;
  padding: 0;
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
  height: 26px; /* Altura específica para hacer el input más delgado */
}

.search-input:focus {
  outline: none;
}

.search-input::placeholder {
  color: #969696;
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
}

.search-button:hover,
.list-button:hover {
  color: white;
}

.title-text {
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  color: white;
  padding: 15px;
}

.card-title {
  font-size: 16px;
  font-weight: 700;
  color: white;
  margin-bottom: 8px;
}

.card-description {
  font-size: 14px;
  color: #b3b3b3;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Eliminar los estilos anteriores de h1, h2, h3 */
.library-title .title-text {
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin: 0;
}

.playlists-container {
  margin-top: 16px;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
}

.playlist-item {
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 12px;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.playlist-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.playlist-item.active {
  background-color: rgba(255, 255, 255, 0.2);
}

.playlist-image {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.sidebar.collapsed .playlist-image {
  width: 48px;
  height: 48px;
  margin: 0 auto 10px;
}

.sidebar.collapsed .playlist-item {
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px 5px;
}

.sidebar.collapsed .playlist-info {
  display: none;
}

.playlist-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.playlist-image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.playlist-icon {
  font-size: 24px;
  color: #b3b3b3;
}

.playlist-info {
  flex: 1;
  min-width: 0;
}

.playlist-title {
  font-size: 14px;
  font-weight: 500;
  color: white;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.playlist-subtitle {
  font-size: 12px;
  color: #b3b3b3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Personalizar scrollbar para playlists-container */
.playlists-container::-webkit-scrollbar {
  width: 8px;
}

.playlists-container::-webkit-scrollbar-track {
  background: transparent;
}

.playlists-container::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.playlists-container::-webkit-scrollbar-thumb:hover {
  background: #666;
}

.cards-grid-scroll {
  /* Original styles, no 5px padding */
  overflow-x: auto;
  padding-bottom: 20px;
  margin-bottom: 28px;
  position: relative;
  scrollbar-width: thin;
  -ms-overflow-style: none;
  width: 100%;
}

.cards-grid-scroll::-webkit-scrollbar {
  height: 6px;
}

.cards-grid-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.cards-grid-scroll::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.cards-grid-scroll::-webkit-scrollbar-thumb:hover {
  background: #666;
}

.cards-grid-horizontal {
  display: flex;
  gap: 24px;
  padding: 4px;
  width: max-content; /* Asegura que no se compriman las cards */
  min-width: 100%;
}

.cards-grid-horizontal .card {
  width: 200px; /* Ancho fijo para cada card */
  min-width: 200px; /* Asegura que nunca sea más pequeño */
  flex-shrink: 0; /* Impide que las cards se compriman */
}

.cards-grid-horizontal .radio-card {
  width: calc((100% - 96px) / 5);
  min-width: 180px;
  max-width: 200px;
  flex-shrink: 0;
}

/* Asegurarse de que las imágenes mantengan su aspecto */
.radio-card .radio-image {
  width: 100%;
  aspect-ratio: 1;
}

.popular-stations.full-view {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #121212;
  z-index: 10;
  padding: 24px;
  overflow-y: auto;
}

.sidebar.collapsed ~ .contenido .popular-stations.full-view {
  left: calc(72px + 16px);
}

.full-view .cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px;
  padding: 20px 0;
}

.full-view .section-header {
  position: sticky;
  top: 0;
  background-color: #121212;
  padding: 16px 0;
  z-index: 11;
  margin-bottom: 24px;
}

/* Ocultar otras secciones cuando está en vista completa */
.popular-stations.full-view ~ section {
  display: none;
}

.made-for-section {
  transition: opacity 0.3s ease;
  padding: 5px; /* Añadir padding de 5px */
}

.back-button {
  background: none;
  border: none;
  color: white;
  font-size: 28px;
  cursor: pointer;
  padding: 8px;
  margin-right: 16px;
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s;
  border-radius: 50%;
}

.back-button:hover {
  transform: scale(1.1);
  background-color: rgba(255, 255, 255, 0.1);
}

/* Estilos para la vista completa (común para ambas secciones) */
.full-view {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #121212;
  z-index: 10;
  padding: 24px;
  overflow-y: auto;
}

.full-view .section-header {
  position: sticky;
  top: 0;
  background-color: #121212;
  padding: 16px 0;
  z-index: 11;
  margin-bottom: 24px;
}

.full-view .cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px;
  padding: 20px 0;
}

/* Ocultar secciones cuando una está en vista completa */
.made-for-section.full-view ~ section,
.popular-stations.full-view ~ section {
  display: none;
}

/* Asegurar que las cards mantengan su aspecto en vista completa */
.full-view .card,
.full-view .radio-card {
  width: 100%;
  height: 100%;
}

.full-view .card-image,
.full-view .radio-image {
  width: 100%;
  aspect-ratio: 1;
}

/* Estilos para el botón de regresar */
.back-button {
  background: none;
  border: none;
  color: white;
  font-size: 28px;
  cursor: pointer;
  padding: 8px;
  margin-right: 16px;
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s;
  border-radius: 50%;
}

.back-button:hover {
  transform: scale(1.1);
  background-color: rgba(255, 255, 255, 0.1);
}

/* Transiciones suaves */
.made-for-section,
.popular-stations {
  transition: all 0.3s ease;
  padding: 5px; /* Añadir padding de 5px */
}

/* Estilos para la vista de detalle de lista */
.list-detail-view {
  height: 100%;
  position: relative;
  overflow-y: auto;
}

.list-detail-header {
  position: relative;
  z-index: 2;
}

.list-detail-content {
  position: relative;
  z-index: 1;
  background-color: #121212;
}

.list-header {
  position: relative;
  display: flex;
  padding: 64px 32px 0;
  gap: 24px;
  align-items: flex-end;
}

.list-cover {
  width: 232px;
  height: 232px;
  box-shadow: 0 4px 60px rgba(0, 0, 0, .5);
  position: relative;
  overflow: hidden;
}

.list-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
}

.list-cover:hover .cover-overlay {
  opacity: 1;
}

.overlay-text {
  color: white;
  font-size: 16px;
  font-weight: 600;
  margin-top: 12px;
}

.hidden-file-input {
  display: none;
}

.list-info {
  flex: 1;
}

.list-type {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.list-title {
  font-size: 96px;
  font-weight: 900;
  margin: 8px 0;
  line-height: 96px;
}

.list-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #b3b3b3;
  font-size: 14px;
}

.owner-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.owner-name {
  color: white;
  font-weight: 700;
}

.playback-controls {
  padding: 24px 32px;
}

.playback-info {
  display: flex;
  align-items: center;
  gap: 24px;
}

.play-button {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: #1ed760;
  border: none;
  color: black;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  opacity: 0;
}

.playback-info:hover .play-button {
  opacity: 1;
}

.play-button:hover {
  transform: scale(1.05);
  background-color: #1fdf64;
}

.playback-title {
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.playback-info:hover .playback-title {
  color: white;
}

.songs-list {
  padding: 0 32px;
}

.songs-header {
  display: grid;
  grid-template-columns: 48px 4fr 2fr 2fr 1fr;
  padding: 8px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #b3b3b3;
  font-size: 14px;
  font-weight: 500;
}

.songs-container {
  margin-top: 16px;
}

.song-item {
  display: grid;
  grid-template-columns: 48px 4fr 2fr 2fr 1fr;
  padding: 8px 16px;
  color: #b3b3b3;
  border-radius: 4px;
  font-size: 14px;
  align-items: center;
}

.song-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.song-title {
  display: flex;
  align-items: center;
  gap: 16px;
}

.song-cover {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 50%;
}

.song-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.song-name {
  color: white;
  font-weight: 500;
}

.song-artist {
  color: #b3b3b3;
}

.song-number, .song-duration {
  text-align: center;
}

.song-duration {
  text-align: right;
  padding-right: 16px;
}

/* Ajustar el scroll para la vista de detalle */
.list-detail-view {
  height: 100%;
  overflow-y: auto;
}

.list-detail-view::-webkit-scrollbar {
  width: 8px;
}

.list-detail-view::-webkit-scrollbar-track {
  background: transparent;
}

.list-detail-view::-webkit-scrollbar-thumb {
  background: #555;
  border-radius: 4px;
}

.list-detail-view::-webkit-scrollbar-thumb:hover {
  background: #666;
}

.song-verified {
  text-align: center;
}

.verified-badge {
  color: #1ed760;
  font-size: 18px;
  font-weight: bold;
}

.profile-link {
  color: #b3b3b3;
  text-decoration: none;
  font-size: 12px;
}

.profile-link:hover {
  color: white;
  text-decoration: underline;
}

.loading-message,
.empty-message {
  grid-column: 1 / -1;
  text-align: center;
  padding: 32px;
  color: #b3b3b3;
  font-size: 16px;
  background: #181818;
  border-radius: 8px;
}

.loading-message {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 0.6; }
  50% { opacity: 1; }
  100% { opacity: 0.6; }
}

.detail-back {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 32px;
  height: 32px;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.detail-back:hover {
  background-color: rgba(0, 0, 0, 0.9);
  transform: scale(1.1);
}

.floating-nav {
  position: sticky;
  top: 0;
  height: 64px;
  background-color: rgba(18, 18, 18, 0.85);
  backdrop-filter: blur(12px);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  z-index: 3;
  padding: 0 32px;
  display: flex;
  align-items: center;
  margin: 0;
}

.floating-nav.visible {
  opacity: 1;
  visibility: visible;
}

.nav-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.nav-list-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.nav-cover {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  object-fit: cover;
}

.nav-title {
  font-size: 16px;
  font-weight: 700;
  color: white;
}

.nav-play {
  width: 32px;
  height: 32px;
  font-size: 16px;
  opacity: 1;
  background-color: #1ed760;
}

.create-button {
  width: auto;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.15);
  color: white;
  transition: all 0.3s ease;
}

.create-button:hover {
  background-color: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}

.create-text {
  font-size: 14px;
  margin-left: 2px;
  color: white;
  font-weight: 500;
}

.create-icon {
  color: white;
  font-size: 18px;
}

.dropdown-container {
  position: relative;
  z-index: 9999; /* Valor extremadamente alto para asegurar que esté por encima de todo */
}

.hover-text {
  z-index: 1000;
}

.create-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  background-color: #282828;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  padding: 8px;
  z-index: 9999; /* Valor extremadamente alto para asegurar que esté por encima de todo */
  width: 360px;
  animation: regularFadeIn 0.2s ease;
  /* Asegurar que el menú esté por encima de todos los elementos */
  transform: translateZ(0);
}

@keyframes regularFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.create-menu-item {
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 4px;
  margin-bottom: 4px;
}

.create-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-item-icon {
  margin-right: 16px;
  width: 56px;
  height: 56px;
  background-color: #333;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
}

.menu-icon {
  width: 20px;
  display: inline-flex;
  justify-content: center;
  color: #b3b3b3;
}

.menu-icon i {
  font-size: 16px;
}

.menu-item-content {
  display: flex;
  flex-direction: column;
}

.menu-item-title {
  font-size: 16px;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
}

.menu-item-description {
  font-size: 14px;
  color: #b3b3b3;
}

.create-menu-item:hover .menu-item-icon {
  background-color: rgba(29, 185, 84, 0.2);
}

.create-menu-item:hover .menu-icon {
  color: #1DB954;
}

.collapsed-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.collapsed-button {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.collapsed-button:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.parallel-lines {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
}

.line {
  width: 100%;
  height: 2px;
  background-color: white;
  border-radius: 1px;
  transition: all 0.3s ease;
}

.collapsed-button:hover .line:first-child {
  transform: translateY(1px);
}

.collapsed-button:hover .line:last-child {
  transform: translateY(-1px);
}

.plus-icon {
  font-size: 20px;
  color: white;
}

.create-collapsed-button {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.create-collapsed-button:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

/* Nuevos estilos para la barra lateral colapsada */
.collapsed-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  padding-top: 20px;
}

.collapsed-icon-container {
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.collapsed-icon {
  background: none;
  border: none;
  color: #b3b3b3;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.collapsed-icon:hover {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  transform: scale(1.05);
}

.collapsed-icon:active {
  transform: scale(0.95);
}

.arrow-icon {
  position: relative;
  width: 16px;
  height: 16px;
  transition: all 0.2s ease;
}

.arrow-right {
  position: absolute;
  top: 50%;
  left: 0;
  width: 16px;
  height: 2px;
  background-color: currentColor;
  transform: translateY(-50%);
}

.arrow-right:before,
.arrow-right:after {
  content: '';
  position: absolute;
  right: 0;
  width: 8px;
  height: 2px;
  background-color: currentColor;
}

.arrow-right:before {
  top: -3px;
  transform: rotate(-45deg);
  transform-origin: right;
}

.arrow-right:after {
  top: 3px;
  transform: rotate(45deg);
  transform-origin: right;
}

.collapsed-icon:hover .arrow-icon {
  transform: translateX(2px);
}

.add-chip {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  width: auto;
  padding: 0 15px;
  height: 32px;
  font-size: 22px;
}

.add-chip:hover {
  background-color: rgba(255, 255, 255, 0.2);
  color: #1DB954;
}

.collapsed-playlists {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  overflow-y: auto;
  width: 100%;
  padding: 10px 0;
  max-height: calc(100% - 180px);
}

.collapsed-playlist-item {
  cursor: pointer;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  transition: all 0.2s ease;
  position: relative;
}

.collapsed-playlist-item:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.collapsed-playlist-item.active {
  box-shadow: 0 0 0 2px #1DB954;
}

.collapsed-playlist-item.active::after {
  content: '';
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #1DB954;
}

.collapsed-playlist-image {
  width: 100%;
  height: 100%;
}

.collapsed-playlist-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.collapsed-playlist-placeholder {
  width: 100%;
  height: 100%;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
}

.collapsed-create-menu {
  position: absolute;
  top: 100%;
  left: -240px;
  right: auto;
  transform: none;
  margin-top: 10px;
  z-index: 9999; /* Valor extremadamente alto para asegurar que esté por encima de todo */
  width: 280px !important;
  transform-origin: top right;
  animation: collapsedFadeInLeft 0.2s ease;
}

@keyframes collapsedFadeInLeft {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.position-relative {
  position: relative;
}

/* Menú de opciones para la lista */
.list-options-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  margin-top: 16px;
  background-color: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.left-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.right-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.list-actions {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-action-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.menu-action-btn:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.list-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  background-color: #282828;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  padding: 4px;
  z-index: 9999; /* Valor extremadamente alto para asegurar que esté por encima de todo */
  width: 280px;
  animation: regularFadeIn 0.2s ease;
}

@keyframes regularFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 4px;
  margin-bottom: 2px;
  position: relative;
}

.menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-icon {
  width: 20px;
  display: inline-flex;
  justify-content: center;
  color: #b3b3b3;
}

.menu-icon i {
  font-size: 16px;
}

.menu-text {
  margin-left: 12px;
  font-size: 14px;
  color: white;
  flex: 1;
}

.arrow-icon {
  position: absolute;
  right: 12px;
  color: #b3b3b3;
}

.arrow-icon i {
  font-size: 14px;
}

.list-search {
  flex: 1;
  max-width: 300px;
  display: flex;
  align-items: center;
}

.search-input-container.list-search-container {
  display: flex;
  align-items: center;
  background-color: #242424;
  border-radius: 4px;
  padding: 6px 12px;
  width: 100%;
}

.search-input.list-search-input {
  background: transparent;
  border: none;
  color: white;
  font-size: 14px;
  width: 100%;
}

.search-input.list-search-input:focus {
  outline: none;
}

.dots-icon {
  font-size: 18px;
  letter-spacing: 1px;
}

.add-btn {
  background-color: #1DB954;
  color: white;
  border-radius: 20px;
  width: auto;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
}

.add-btn:hover {
  background-color: #1ed760;
  transform: scale(1.02);
}

.add-icon {
  font-size: 18px;
  font-weight: bold;
}

.add-text {
  font-size: 14px;
  font-weight: 500;
}

/* Estilos para el sidebar de agregar influencers */
.add-influencer-sidebar {
  position: fixed;
  top: 0;
  right: -450px;
  width: 450px;
  height: 100vh;
  background-color: #282828;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
  z-index: 1100;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  color: white;
}

.add-influencer-sidebar.open {
  right: 0;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.sidebar-overlay.visible {
  opacity: 1;
  visibility: visible;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  /* Eliminar el borde inferior */
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.1); */
}

.sidebar-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.close-button {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: all 0.2s;
}

.close-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.sidebar-content {
  flex: 1;
  padding: 5px; /* Añadir padding de 5px */
  overflow-y: auto;
}

.sidebar-footer {
  padding: 10px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Eliminar el borde superior */
  /* border-top: 1px solid rgba(255, 255, 255, 0.1); */
}

.cancel-button {
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 8px 16px;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.2s;
}

.cancel-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.add-button {
  background-color: #1DB954;
  border: none;
  color: white;
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.add-button:hover:not(:disabled) {
  background-color: #1ed760;
  transform: scale(1.05);
}

.add-button:disabled {
  background-color: #1DB95480;
  cursor: not-allowed;
}

.filter-section, .search-results {
  margin-bottom: 24px;
}

.filter-group {
  margin-bottom: 16px;
}

.filter-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #b3b3b3;
}

.filter-select {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  background-color: #333;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

.followers-range {
  display: flex;
  align-items: center;
  gap: 10px;
}

.followers-input {
  flex: 1;
  padding: 10px;
  border-radius: 4px;
  background-color: #333;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
}

.loading-results, .empty-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  text-align: center;
  color: #b3b3b3;
}

.spinner-container {
  margin-bottom: 16px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-top-color: #1DB954;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.empty-icon {
  color: #b3b3b3;
  margin-bottom: 16px;
}

.influencer-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.influencer-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background-color: #333;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.influencer-item:hover {
  background-color: #444;
}

.influencer-item.selected {
  background-color: rgba(29, 185, 84, 0.1);
  border: 1px solid rgba(29, 185, 84, 0.5);
}

.influencer-avatar {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
}

.influencer-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.network-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #282828;
}

.network-instagram {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
}

.network-youtube {
  background-color: #FF0000;
}

.network-tiktok {
  background-color: #000000;
}

.network-twitter {
  background-color: #1DA1F2;
}

.influencer-info {
  flex: 1;
}

.influencer-name {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 4px;
}

.influencer-stats {
  font-size: 14px;
  color: #b3b3b3;
  margin: 0;
}

.selection-checkbox {
  margin-left: 16px;
}

.text-primary {
  color: #1DB954;
}

.text-muted {
  color: #b3b3b3;
}

/* Estilos para el buscador dentro del sidebar */
.search-container {
  margin-bottom: 24px;
}

.search-input-container {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #b3b3b3;
}

.search-input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border-radius: 4px;
  background-color: #333;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #1DB954;
}

.mb-3 {
  margin-bottom: 16px;
}

.mb-4 {
  margin-bottom: 24px;
}

/* Asegurar que los elementos estén siempre visibles */
.always-top {
  position: relative !important;
  z-index: 9999 !important;
}

/* Portal para menús */
.menu-portal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999;
}

.portal-menu {
  position: absolute;
  background-color: #282828;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  padding: 8px;
  pointer-events: auto;
}

.create-menu-portal {
  width: 360px;
  animation: regularFadeIn 0.2s ease;
}

/* Estilo para asegurar que los eventos de click funcionen correctamente */
.create-menu-item, .menu-item {
  position: relative;
  z-index: 2;
}

/* Estilos para el modal de edición */
.list-title {
  cursor: pointer;
  transition: color 0.2s ease;
}

.list-title:hover {
  color: #1DB954;
}

.edit-list-modal {
  background-color: #121212 !important;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.3) !important;
  max-width: 600px !important;
  margin: 0 auto !important;
  padding: 0 !important;
}

.edit-list-modal-dialog {
  max-width: 600px !important;
}

/* Asegurarse de que todos los elementos dentro del modal tengan texto blanco */
.edit-list-modal,
.edit-list-modal * {
  color: white;
}

.edit-list-modal-body {
  padding: 0 !important;
  background-color: #121212 !important;
}

.edit-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px;
}

.edit-modal-title {
  color: white !important;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.edit-modal-title * {
  color: white !important;
}

.edit-modal-close {
  background: none;
  border: none;
  color: #b3b3b3;
  font-size: 32px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  margin-right: -8px;
}

.edit-modal-close:hover {
  color: white;
}

.edit-modal-content {
  padding: 0 24px 24px;
}

.edit-modal-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.edit-modal-cover-container {
  flex-shrink: 0;
}

.edit-modal-cover {
  width: 180px;
  height: 180px;
  background-color: #333;
  box-shadow: 0 4px 60px rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-modal-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.edit-modal-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.edit-form-control {
  width: 100%;
  background-color: #3e3e3e;
  border: none;
  border-radius: 4px;
  color: white;
  padding: 12px 16px;
  font-size: 14px;
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.5;
  letter-spacing: 0.25px;
}

.edit-form-control:focus {
  outline: none;
  background-color: #535353;
}

.edit-form-control::placeholder {
  color: #b3b3b3;
}

.edit-modal-disclaimer {
  color: #b3b3b3;
  font-size: 12px;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 90%;
  text-align: center;
  margin-bottom: 24px;
}

.edit-modal-actions {
  display: flex;
  justify-content: flex-end;
}

.edit-save-btn {
  background-color: white;
  color: black;
  border-radius: 32px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.edit-save-btn:hover {
  transform: scale(1.04);
  background-color: white;
}

/* Estilos para el modal de edición customizado */
.custom-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.custom-modal {
  background-color: #121212;
  color: white;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  margin: 20px;
  overflow: hidden;
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.3);
  animation: modal-appear 0.3s ease;
}

.custom-modal h3,
.custom-modal input,
.custom-modal textarea,
.custom-modal .edit-modal-title {
  color: white !important;
}

/* Forzar color de texto blanco en todos los elementos del modal */
.custom-modal * {
  color: white;
}

@keyframes modal-appear {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}

.list-title {
  cursor: pointer;
  transition: color 0.2s ease;
}

.list-title:hover {
  color: #1DB954;
}

.edit-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 16px;
}

.edit-modal-title {
  color: white !important;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}

.edit-modal-title * {
  color: white !important;
}

.edit-modal-close {
  background: none;
  border: none;
  color: #b3b3b3;
  font-size: 32px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  margin-right: -8px;
}

.edit-modal-close:hover {
  color: white;
}

.edit-modal-content {
  padding: 0 24px 24px;
}

.edit-modal-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
}

.edit-modal-cover-container {
  flex-shrink: 0;
}

.edit-modal-cover {
  width: 180px;
  height: 180px;
  background-color: #333;
  box-shadow: 0 4px 60px rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-modal-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.edit-modal-form {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.edit-form-control {
  width: 100%;
  background-color: #3e3e3e;
  border: none;
  border-radius: 4px;
  color: white;
  padding: 12px 16px;
  font-size: 14px;
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.5;
  letter-spacing: 0.25px;
}

.edit-form-control:focus {
  outline: none;
  background-color: #535353;
}

.edit-form-control::placeholder {
  color: #b3b3b3;
}

.edit-modal-disclaimer {
  color: #b3b3b3;
  font-size: 12px;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 90%;
  text-align: center;
  margin-bottom: 24px;
}

.edit-modal-actions {
  display: flex;
  justify-content: flex-end;
}

.edit-save-btn {
  background-color: white;
  color: black;
  border-radius: 32px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.edit-save-btn:hover {
  transform: scale(1.04);
  background-color: white;
}

/* Media queries para responsividad */
@media (max-width: 768px) {
  .edit-modal-row {
    flex-direction: column;
    align-items: center;
  }
  
  .edit-modal-cover {
    margin-bottom: 24px;
  }
}

/* Estilos para la sección de listas destacadas */
.section-block {
  /* Restaurar los valores originales */
  margin-top: 48px;
  padding: 24px;
  background-color: #181818;
  border-radius: 8px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

.featured-lists-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columnas para mostrar 3 por fila */
  gap: 24px;
  max-width: 100%;
}

.featured-list-card {
  background: transparent; /* Cambiar de #282828 a transparent */
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s;
  height: auto; /* Para que la altura se ajuste al contenido */
  border: none;
  box-shadow: none;
}

.featured-list-card:hover {
  transform: scale(1.05);
}

.featured-card-image {
  width: 100%;
  height: 300px; /* Altura doble */
  position: relative;
  overflow: hidden;
}

.featured-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.featured-card-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1; /* Para que ocupe el espacio disponible */
}

.featured-card-title {
  font-size: 16px;
  font-weight: 700;
  color: white;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 20px); /* Ajustado para asegurar que quede dentro de la tarjeta */
  width: 100%;
}

.featured-card-subtitle {
  font-size: 14px;
  color: #b3b3b3;
  margin-bottom: 12px;
}

.featured-card-description {
  font-size: 12px;
  color: #a7a7a7;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limitar a 2 líneas */
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.card-header-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 97px); /* Ancho ajustado: 100% menos el ancho de la imagen (81px) y el margen (16px) */
  margin-top: 8px; /* Espacio adicional arriba del texto */
  overflow: hidden; /* Asegurar que el contenido no se salga */
}

/* Estilos específicos para las tarjetas en popular-stations */
.popular-stations .radio-card {
  /* Mantener solo el ancho original */
  width: calc((100% - 96px) / 5);
  min-width: 180px;
  max-width: 200px;
  flex-shrink: 0;
}

/* Ajustar las imágenes a la misma altura que "Tus listas" */
.popular-stations .radio-card .radio-image {
  width: 100%;
  aspect-ratio: 1; /* Igual que las tarjetas de "Tus listas" */
  position: relative;
  overflow: hidden;
}

/* Mantener la posición del label RADIO */
.popular-stations .radio-card .radio-label {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 4px 8px;
  background-color: rgba(0, 0, 0, 0.6);
  font-size: 10px;
  font-weight: 700;
  border-radius: 4px;
  z-index: 1;
}

/* Asegurarnos que las imágenes se ajusten correctamente */
.popular-stations .radio-card .radio-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Estilos específicos para las tarjetas en la sección de listas destacadas */
.featured-lists-section .featured-list-card {
  background: transparent; /* Cambiar de #282828 a transparent */
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s;
  height: auto; /* Para que la altura se ajuste al contenido */
  border: none;
  box-shadow: none;
}

.featured-lists-section .featured-list-card:hover {
  transform: scale(1.05);
}

/* Hacemos que las imágenes de las tarjetas sean el doble de altas */
.featured-lists-section .featured-card-image {
  width: 100%;
  height: 300px; /* Hacer el doble de alto (original 150px) */
  position: relative;
  overflow: hidden;
}

/* Asegurarnos que las imágenes se ajusten correctamente */
.featured-lists-section .featured-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.featured-lists-section .featured-card-content {
  padding: 16px;
}

.featured-lists-section .featured-card-title {
  font-size: 16px;
  font-weight: 700;
  color: white;
  margin-bottom: 8px;
}

.featured-lists-section .featured-card-subtitle {
  font-size: 14px;
  color: #b3b3b3;
}

/* Estilos actualizados para las tarjetas estilo Spotify */
.spotify-style-card {
  width: 95%; /* Ligeramente más delgada */
  height: 400px; /* Más larga (era 360px) */
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-size: cover;
  background-color: transparent; /* Asegurar que no haya color de fondo */
  box-shadow: none; /* Eliminar cualquier sombra */
  border: none; /* Eliminar cualquier borde */
  cursor: pointer;
  margin: 0 auto; /* Centrar la tarjeta */
}

.spotify-style-card .card-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  background-color: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  flex-direction: row; /* Cambio a fila para poner el título a la derecha */
}

.card-thumbnail {
  width: 81px; /* Reducido un 10% de 90px */
  height: 81px; /* Reducido un 10% de 90px */
  margin-right: 16px; /* Espacio entre la imagen y el texto */
  margin-bottom: 0; /* Eliminar margen inferior */
  position: relative;
  flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(0,0,0,0.3);
}

.card-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-header-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 97px); /* Ancho ajustado: 100% menos el ancho de la imagen (81px) y el margen (16px) */
  margin-top: 8px; /* Espacio adicional arriba del texto */
  overflow: hidden; /* Asegurar que el contenido no se salga */
}

.card-main-title {
  font-size: 28px;
  font-weight: 700;
  color: white; /* Asegurar que sea blanco */
  margin: 0 0 8px 0;
  line-height: 1.1;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 20px); /* Ajustado para asegurar que quede dentro de la tarjeta */
  width: 100%;
}

.card-subtitle {
  font-size: 14px;
  color: rgba(255,255,255,0.7);
  margin: 0;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.card-content-area {
  flex-grow: 1;
}

.card-description {
  font-size: 14px;
  color: rgba(255,255,255,0.7);
  margin-top: auto;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

/* Gradientes para los fondos */
.gradient-purple { background: linear-gradient(135deg, #450af5, #c4efd9); }
.gradient-blue { background: linear-gradient(135deg, #1e3264, #b4b4b4); }
.gradient-cyan { background: linear-gradient(135deg, #148a08, #b4b4b4); }
.gradient-red { background: linear-gradient(135deg, #e61e32, #b4b4b4); }
.gradient-pink { background: linear-gradient(135deg, #bc5900, #b4b4b4); }

/* Cuadrícula para las listas destacadas */
.featured-lists-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  max-width: 100%;
}

/* Estilos para la sección de listas destacadas */
.featured-lists-section {
  margin-top: 48px;
  margin-bottom: 48px; /* Espacio al final de la sección */
  padding: 5px; /* Padding de 5px a toda la sección */
}

.featured-lists-section .section-header {
  margin-bottom: 24px;
}

.featured-lists-section .section-title {
  font-size: 22px;
  font-weight: bold;
  color: #FFFFFF !important; /* Título en blanco */
}

/* Estilos para las imágenes de las tarjetas destacadas */
.featured-lists-section .featured-card-image {
  width: 100%;
  height: 300px; /* Altura doble */
  position: relative;
  overflow: hidden;
}

.featured-lists-section .featured-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Estilos CSS para la descripción en hover */
.spotify-style-card {
  width: 95%; 
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-size: cover;
  background-color: transparent;
  box-shadow: none;
  border: none;
  cursor: pointer;
  margin: 0 auto;
}

.card-hover-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0,0,0,0.7));
  padding: 48px 16px 16px;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease;
}

.spotify-style-card:hover .card-hover-overlay {
  opacity: 1;
  transform: translateY(0);
}

.card-description {
  font-size: 14px;
  color: rgba(255,255,255,0.9);
  margin-top: auto;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

/* Gradientes para los fondos con animación */
.gradient-purple { 
  background: linear-gradient(135deg, #450af5, #c4efd9);
  background-size: 200% 200%;
  animation: gradientAnimation 15s ease infinite;
}
.gradient-blue { 
  background: linear-gradient(135deg, #1e3264, #5ebef0);
  background-size: 200% 200%;
  animation: gradientAnimation 15s ease infinite;
}
.gradient-cyan { 
  background: linear-gradient(135deg, #148a08, #8eff8c);
  background-size: 200% 200%;
  animation: gradientAnimation 15s ease infinite;
}
.gradient-red { 
  background: linear-gradient(135deg, #e61e32, #ffa3a3);
  background-size: 200% 200%;
  animation: gradientAnimation 15s ease infinite;
}
.gradient-pink { 
  background: linear-gradient(135deg, #bc5900, #ffcf87);
  background-size: 200% 200%;
  animation: gradientAnimation 15s ease infinite;
}

/* Keyframes para la animación del gradiente */
@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* Gradientes para los fondos con animación más pronunciada */
.gradient-purple { 
  background: linear-gradient(135deg, #450af5, #c4efd9);
  background-size: 400% 400%;
  animation: gradientAnimation 8s ease infinite, rotateGradient 12s linear infinite;
}
.gradient-blue { 
  background: linear-gradient(135deg, #1e3264, #5ebef0);
  background-size: 400% 400%;
  animation: gradientAnimation 7s ease infinite, rotateGradient 14s linear infinite;
}
.gradient-cyan { 
  background: linear-gradient(135deg, #148a08, #8eff8c);
  background-size: 400% 400%;
  animation: gradientAnimation 9s ease infinite, rotateGradient 15s linear infinite;
}
.gradient-red { 
  background: linear-gradient(135deg, #e61e32, #ffa3a3);
  background-size: 400% 400%;
  animation: gradientAnimation 6s ease infinite, rotateGradient 13s linear infinite;
}
.gradient-pink { 
  background: linear-gradient(135deg, #bc5900, #ffcf87);
  background-size: 400% 400%;
  animation: gradientAnimation 8s ease infinite, rotateGradient 11s linear infinite;
}

/* Keyframes para la animación del gradiente mejorada */
@keyframes gradientAnimation {
  0% {
    background-position: 0% 0%;
  }
  25% {
    background-position: 100% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  75% {
    background-position: 0% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}

/* Nueva animación para rotar el gradiente */
@keyframes rotateGradient {
  0% {
    filter: hue-rotate(0deg);
  }
  50% {
    filter: hue-rotate(30deg);
  }
  100% {
    filter: hue-rotate(0deg);
  }
}

/* Animaciones aceleradas para el hover */
.spotify-style-card:hover.gradient-purple {
  animation: gradientAnimation 2s ease infinite, rotateGradient 3s linear infinite;
}

.spotify-style-card:hover.gradient-blue {
  animation: gradientAnimation 1.5s ease infinite, rotateGradient 2.5s linear infinite;
}

.spotify-style-card:hover.gradient-cyan {
  animation: gradientAnimation 1.8s ease infinite, rotateGradient 2.8s linear infinite;
}

.spotify-style-card:hover.gradient-red {
  animation: gradientAnimation 1.2s ease infinite, rotateGradient 2s linear infinite;
}

.spotify-style-card:hover.gradient-pink {
  animation: gradientAnimation 1.6s ease infinite, rotateGradient 2.2s linear infinite;
}

/* Animación de rotación más intensa para hover */
@keyframes fastRotateGradient {
  0% {
    filter: hue-rotate(0deg) brightness(1);
  }
  25% {
    filter: hue-rotate(45deg) brightness(1.1);
  }
  50% {
    filter: hue-rotate(90deg) brightness(1.05);
  }
  75% {
    filter: hue-rotate(45deg) brightness(1.1);
  }
  100% {
    filter: hue-rotate(0deg) brightness(1);
  }
}

/* Animaciones extremadamente rápidas para el hover */
.spotify-style-card:hover.gradient-purple {
  animation: gradientAnimation 0.5s ease infinite, rotateGradient 0.7s linear infinite;
}

.spotify-style-card:hover.gradient-blue {
  animation: gradientAnimation 0.4s ease infinite, rotateGradient 0.6s linear infinite;
}

.spotify-style-card:hover.gradient-cyan {
  animation: gradientAnimation 0.45s ease infinite, rotateGradient 0.65s linear infinite;
}

.spotify-style-card:hover.gradient-red {
  animation: gradientAnimation 0.3s ease infinite, rotateGradient 0.5s linear infinite;
}

.spotify-style-card:hover.gradient-pink {
  animation: gradientAnimation 0.4s ease infinite, rotateGradient 0.55s linear infinite;
}

/* Animación de rotación más intensa para hover */
@keyframes rotateGradient {
  0% {
    filter: hue-rotate(0deg);
  }
  50% {
    filter: hue-rotate(60deg);
  }
  100% {
    filter: hue-rotate(0deg);
  }
}

/* Estilo base para los círculos flotantes */
.spotify-style-card {
  width: 95%; 
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-size: cover;
  background-color: transparent;
  box-shadow: none;
  border: none;
  cursor: pointer;
  margin: 0 auto;
}

/* Primer círculo - grande y lento */
.spotify-style-card::before {
  content: "";
  position: absolute;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  filter: blur(40px);
  top: -50px;
  left: -50px;
  z-index: 0;
  opacity: 0.7;
  transition: opacity 0.3s ease;
  animation: floatingCircle1 15s infinite alternate ease-in-out;
}

/* Segundo círculo - mediano y más rápido */
.spotify-style-card::after {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  filter: blur(30px);
  bottom: 30px;
  right: -30px;
  z-index: 0;
  opacity: 0.6;
  transition: opacity 0.3s ease;
  animation: floatingCircle2 12s infinite alternate ease-in-out;
}

/* Activar círculos adicionales solo en hover */
.spotify-style-card:hover::before,
.spotify-style-card:hover::after {
  opacity: 0.9;
}

/* Círculos adicionales visibles siempre, pero intensificados en hover */
.spotify-style-card:hover .hover-circle-1,
.spotify-style-card:hover .hover-circle-2,
.spotify-style-card:hover .hover-circle-3 {
  opacity: 0.9;
}

/* Círculos adicionales siempre visibles */
.spotify-style-card .hover-circle-1 {
  content: "";
  position: absolute;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  filter: blur(20px);
  top: 50%;
  left: 20%;
  z-index: 0;
  opacity: 0.6;
  transition: opacity 0.3s ease;
  animation: floatingCircle3 8s infinite alternate ease-in-out;
}

.spotify-style-card .hover-circle-2 {
  content: "";
  position: absolute;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  filter: blur(15px);
  top: 30%;
  right: 20%;
  z-index: 0;
  opacity: 0.6;
  transition: opacity 0.3s ease;
  animation: floatingCircle4 9s infinite alternate ease-in-out;
}

/* Nuevo círculo adicional */
.spotify-style-card .hover-circle-3 {
  content: "";
  position: absolute;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  filter: blur(25px);
  bottom: 40%;
  left: 40%;
  z-index: 0;
  opacity: 0.6;
  transition: opacity 0.3s ease;
  animation: floatingCircle5 11s infinite alternate ease-in-out;
}

/* Animaciones para los círculos */
@keyframes floatingCircle1 {
  0% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    transform: translate(80px, 80px) scale(1.2);
  }
}

@keyframes floatingCircle2 {
  0% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    transform: translate(-60px, -40px) scale(1.3);
  }
}

@keyframes floatingCircle3 {
  0% {
    transform: translate(0, 0) scale(1);
    filter: blur(20px);
  }
  50% {
    filter: blur(25px);
  }
  100% {
    transform: translate(30px, -30px) scale(1.5);
    filter: blur(15px);
  }
}

@keyframes floatingCircle4 {
  0% {
    transform: translate(0, 0) scale(1);
    filter: blur(15px);
  }
  50% {
    filter: blur(20px);
  }
  100% {
    transform: translate(-20px, 20px) scale(1.4);
    filter: blur(10px);
  }
}

@keyframes floatingCircle5 {
  0% {
    transform: translate(0, 0) scale(1);
    filter: blur(10px);
  }
  50% {
    filter: blur(15px);
  }
  100% {
    transform: translate(-10px, 10px) scale(1.3);
    filter: blur(8px);
  }
}

/* Animaciones más moderadas para el hover */
.spotify-style-card:hover.gradient-purple {
  animation: gradientAnimation 0.9s ease infinite, rotateGradient 1.2s linear infinite;
}

.spotify-style-card:hover.gradient-blue {
  animation: gradientAnimation 0.8s ease infinite, rotateGradient 1.1s linear infinite;
}

.spotify-style-card:hover.gradient-cyan {
  animation: gradientAnimation 0.85s ease infinite, rotateGradient 1.15s linear infinite;
}

.spotify-style-card:hover.gradient-red {
  animation: gradientAnimation 0.7s ease infinite, rotateGradient 1.0s linear infinite;
}

.spotify-style-card:hover.gradient-pink {
  animation: gradientAnimation 0.8s ease infinite, rotateGradient 1.05s linear infinite;
}

/* Estilos para el fondo de imágenes de influencers */
.influencers-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0;
  transition: opacity 0.5s ease;
  overflow: hidden;
}

.spotify-style-card:hover .influencers-background {
  opacity: 1;
  z-index: 1; /* Poner por encima de otros elementos decorativos */
}

/* Ocultar los círculos durante el hover para dar protagonismo a las imágenes */
.spotify-style-card:hover .hover-circle-1,
.spotify-style-card:hover .hover-circle-2,
.spotify-style-card:hover .hover-circle-3 {
  opacity: 0;
  transition: opacity 0.3s ease;
}

/* Hacer más visibles las imágenes de influencers */
.influencers-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0;
  transition: opacity 0.5s ease;
  overflow: hidden;
}

.spotify-style-card:hover .influencers-background {
  opacity: 1;
  z-index: 1; /* Poner por encima de otros elementos decorativos */
}

.influencer-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0;
  filter: blur(3px); /* Quitar efectos de color, mantener solo el desenfoque */
  transition: opacity 0.3s ease; /* Simplificar la transición */
  animation: fadeInOut 10s infinite;
  z-index: 1;
}

.spotify-style-card:hover .influencer-bg-image {
  filter: blur(3px); /* Mantener solo el desenfoque */
}

.influencer-bg-image.active {
  opacity: 0.4;
}

.spotify-style-card:hover .influencer-bg-image.active {
  opacity: 0.8;
}

@keyframes fadeInOut {
  0%, 20% {
    opacity: 0.3;
  }
  25%, 45% {
    opacity: 0;
  }
  50%, 70% {
    opacity: 0.3;
  }
  75%, 95% {
    opacity: 0;
  }
  100% {
    opacity: 0.3;
  }
}

/* Ajustar la animación para el hover */
.spotify-style-card:hover .influencer-bg-image {
  animation: fadeInOutHover 5s infinite;
}

@keyframes fadeInOutHover {
  0%, 40% {
    opacity: 0.9;
    filter: blur(3px); /* Sin efectos de brillo o contraste */
  }
  45%, 50% {
    opacity: 0;
  }
  95%, 100% {
    opacity: 0;
  }
}

/* Reducir la animación de colores para no distraer */
.spotify-style-card:hover.gradient-purple,
.spotify-style-card:hover.gradient-blue,
.spotify-style-card:hover.gradient-cyan,
.spotify-style-card:hover.gradient-red,
.spotify-style-card:hover.gradient-pink {
  animation: gradientAnimation 4s ease infinite;
}

/* Ajustar la animación para que las imágenes cambien cada segundo */
.spotify-style-card:hover .influencer-bg-image {
  animation: fadeInOutHover 2s infinite;
  animation-delay: var(--delay, 0s);
}

/* Añadir retrasos escalonados para las imágenes */
.influencer-bg-image:nth-child(1) { --delay: 0s; }
.influencer-bg-image:nth-child(2) { --delay: 0.4s; }
.influencer-bg-image:nth-child(3) { --delay: 0.8s; }
.influencer-bg-image:nth-child(4) { --delay: 1.2s; }
.influencer-bg-image:nth-child(5) { --delay: 1.6s; }

@keyframes fadeInOutHover {
  0%, 40% {
    opacity: 0.9;
    filter: blur(3px); /* Sin efectos de brillo o contraste */
  }
  45%, 50% {
    opacity: 0;
  }
  95%, 100% {
    opacity: 0;
  }
}

/* Quitar las animaciones de cambio de color en gradientes */
.spotify-style-card:hover.gradient-purple,
.spotify-style-card:hover.gradient-blue,
.spotify-style-card:hover.gradient-cyan,
.spotify-style-card:hover.gradient-red,
.spotify-style-card:hover.gradient-pink {
  animation: none; /* Quitar la animación de colores */
}

/* Eliminar animaciones originales que tenían cambios de color */
@keyframes gradientAnimation {
  0%, 100% {
    background-position: 0% 50%;
  }
}

/* Mejoras para los inputs en general */
input, textarea, select {
  font-family: 'Montserrat', 'Helvetica Neue', Arial, sans-serif !important;
  line-height: 1.5;
  letter-spacing: 0.25px;
}

/* Agregar estilos para los chips */
.filter-chips {
  display: flex;
  gap: 10px;
  margin: 20px 20px 30px 20px;
}

.filter-chip {
  border: none;
  background-color: #333;
  color: #b3b3b3;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.filter-chip:hover {
  background-color: #444;
  color: white;
}

.filter-chip.active {
  background-color: white;
  color: black;
}
</style>

